import Form from "@/Form";
import Modal from "@/Modal";

import "./style.css";

export default class SignupModal extends Modal {
  static selector = ".signup-modal";

  modalDidMount = async () => {
    this.formElement = this.modal.querySelector(".signup-modal__form");
    this.form = new Form(this.formElement, {
      onSubmitSucceeded: this.handleFormSubmitSucceeded,
      onSubmitFailed: this.handleSubmitFailed,
      resetAfterSubmit: true,
      gainControlOnSubmitSucceeded: false
    });
  };
  modalWillOpen = async () => {
    this.modal.classList.remove("signup-modal--success");
  };
  modalDidUpdate = async () => {};

  handleFormSubmitSucceeded = () => {
    window.location.href = "/thank-you-page-newsletter/";
  };
}
